import React, { useRef } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import Icon from "./Icon";
import { useOnClickOutside } from "../hooks/useOnClickOutside";
import { useKeyPress } from "../hooks/useKeyPress";
var StyledOverlay = styled(motion.div).withConfig({
  displayName: "Modal__StyledOverlay",
  componentId: "sc-1q65gp-0"
})(["position:fixed;background:rgba(0,0,0,0.7);will-change:opacity;top:0;bottom:0;left:50%;transform:translateX(-50%);width:100%;"]);
var ModalContainer = styled.div.withConfig({
  displayName: "Modal__ModalContainer",
  componentId: "sc-1q65gp-1"
})(["top:0px;left:0px;right:0px;position:fixed;z-index:1002;cursor:pointer;padding:15% 1rem 1rem;width:100%;height:100%;"]);
var StyledModal = styled.div.withConfig({
  displayName: "Modal__StyledModal",
  componentId: "sc-1q65gp-2"
})(["position:relative;padding:1rem;height:auto;cursor:auto;max-height:100%;max-width:600px;background:", ";display:flex;justify-content:space-between;box-shadow:rgba(0,0,0,0.16) 0px 2px 4px 0px;width:100%;border-radius:8px;border:1px solid rgb(189,189,189);margin:0px auto;"], function (props) {
  return props.theme.colors.background;
});
var ModalContent = styled.div.withConfig({
  displayName: "Modal__ModalContent",
  componentId: "sc-1q65gp-3"
})(["display:flex;flex-direction:column;margin:1rem;width:100%;"]);
var ModalClose = styled.div.withConfig({
  displayName: "Modal__ModalClose",
  componentId: "sc-1q65gp-4"
})(["position:absolute;top:0;right:0;margin:1rem;"]);
var ModalCloseIcon = styled(Icon).withConfig({
  displayName: "Modal__ModalCloseIcon",
  componentId: "sc-1q65gp-5"
})(["cursor:pointer;"]);

var Overlay = function Overlay(_ref) {
  var isActive = _ref.isActive;
  return /*#__PURE__*/React.createElement(StyledOverlay, {
    initial: false,
    animate: {
      opacity: isActive ? 1 : 0,
      zIndex: isActive ? 1001 : -1
    },
    transition: {
      duration: 0.2
    }
  });
};

var Modal = function Modal(_ref2) {
  var children = _ref2.children,
      isOpen = _ref2.isOpen,
      setIsOpen = _ref2.setIsOpen;
  var ref = useRef(); // Close modal on outside clicks & `Escape` keypress

  useOnClickOutside(ref, function () {
    return setIsOpen(false);
  });
  useKeyPress("Escape", function () {
    return setIsOpen(false);
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Overlay, {
    isActive: isOpen
  }), isOpen && /*#__PURE__*/React.createElement(ModalContainer, null, /*#__PURE__*/React.createElement(StyledModal, {
    ref: ref
  }, /*#__PURE__*/React.createElement(ModalContent, null, children), /*#__PURE__*/React.createElement(ModalClose, {
    onClick: function onClick() {
      return setIsOpen(false);
    }
  }, /*#__PURE__*/React.createElement(ModalCloseIcon, {
    name: "close"
  })))));
};

export default Modal;